import React from 'react';

const Footer = () => {
  return (
     <>
     <div className='w-full border-t border-gray-400 mt-24'>
         <div className='container mx-auto'>
             <div className='mx-auto text-center py-9 '>
                 <p className='text-base text-gray-600'>Copyright © 2022. All Rights Reserved. </p>
             </div>
         </div>


     </div>

     </>
  );
};

export default Footer;
